'use client';

import { ContentDialog } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import AiVideoGenerationView from './AiVideoGenerationView';

interface AiVideoGenerateModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  projectId: number;
  onGenerateSuccess: () => void;
}

export default function AiVideoGenerateModal({
  isOpen,
  onClose,
  imageUrl,
  projectId,
  onGenerateSuccess,
}: AiVideoGenerateModalProps) {
  const t = useTranslations();

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleGenerateSuccess = useCallback(() => {
    onClose();
    onGenerateSuccess();
  }, [onClose, onGenerateSuccess]);

  return (
    <ContentDialog
      open={isOpen}
      setOpen={(open) => {
        if (!open) onClose();
      }}
      titleNode={t('Editor.ai-video.modal-title')}
      isDefaultFooterButtonsHidden
    >
      <AiVideoGenerationView
        imageUrl={imageUrl}
        projectId={projectId}
        onCancel={handleCancel}
        onGenerateSuccess={handleGenerateSuccess}
      />
    </ContentDialog>
  );
}
